import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styles from './styles.module.scss';
import { sendPostToShopify } from '../../utils';
import Loading from 'components/common/loading';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { getShopifyStatusAsync, selectShopifyStatus } from 'features/payment/payment-slice';
import MessageError from 'components/message-error';

const ShopifyStatus = () => {
  const { token } = useParams();
  const shopifyStatus = useAppSelector(selectShopifyStatus);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getShopifyStatusAsync(token || ''));
  }, []);

  useEffect(() => {
    const { success } = shopifyStatus;
    if (success?.shopifySuccessUrl) {
      sendPostToShopify(success.shopifySuccessUrl);
    }
  }, [shopifyStatus?.success]);

  const { loading, error, errorInfo } = shopifyStatus;
  return (
    <div className={styles.shopify_status}>
      {loading && <Loading fullScreem noBackground />}
      {!loading && error && (
        <div className={styles.shopify_status_error}>
          <MessageError errorInfo={errorInfo} />
        </div>
      )}
    </div>
  );
};

export default ShopifyStatus;
